import { render, staticRenderFns } from "./custom_insulate.vue?vue&type=template&id=2ca829fe&scoped=true&"
import script from "./custom_insulate.vue?vue&type=script&lang=js&"
export * from "./custom_insulate.vue?vue&type=script&lang=js&"
import style0 from "./custom_insulate.vue?vue&type=style&index=0&id=2ca829fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca829fe",
  null
  
)

export default component.exports